/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Alert from '../Alert';
export const AuthPageAlert = ({ loginUrl }) => {
    return (<Alert severity='info'>
      This page is available only for logged in users.{' '}
      <a href='#' style={{ color: '#01639b' }} onClick={(e) => {
            e.preventDefault();
            window.location.assign(`${loginUrl}?redirect=${window.location.href}`);
        }}>
        Click here
      </a>{' '}
      to sign in with your existing Owner Services login, for a personalised ownership experience.
    </Alert>);
};
